import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import { Dispatch } from 'redux'
import { getSalonData } from '../api/salon'
import { RouteType } from '../types/routes'
import { getSalonGuidFromUrlParams, getUrlWithSalonGuid } from '../utils/urlParams'
import { fetchError as salonFetchError, fetchRequest as salonFetchRequest, fetchSuccess as salonFetchSuccess } from '../store/salon/actions'
import { fetchError as employeeFetchError, fetchSuccess as employeeFetchSuccess } from '../store/employees/actions'
import { ApplicationState } from '../store'

type FetchDateProps = {
  dispatch: Dispatch
  navigate?: (url: string) => void
  redirectTo?: RouteType
  onSalonDataFetch?: () => void
}

export const handleFetchSalonData = async ({ dispatch, navigate, redirectTo, onSalonDataFetch }: FetchDateProps) => {
  const salonGuidFromUrlParams = getSalonGuidFromUrlParams()

  dispatch(salonFetchRequest())
  if (!salonGuidFromUrlParams) {
    dispatch(salonFetchError('No salon guid found'))
  } else {
    const salonResponse = await getSalonData(salonGuidFromUrlParams)
    if (salonResponse) {
      console.log('worked')

      dispatch(salonFetchSuccess(salonResponse))
      dispatch(employeeFetchSuccess(salonResponse.mitarbeiter))
      if (navigate && redirectTo) {
        setTimeout(() => {
          navigate(getUrlWithSalonGuid(redirectTo))
        }, 10)
      }
      if (onSalonDataFetch) {
        onSalonDataFetch()
      }
    } else {
      console.log('NOT worked')

      dispatch(employeeFetchError('Error loading employees'))
      dispatch(salonFetchError('Error loading salon data'))
      if (navigate) {
        setTimeout(() => {
          navigate(getUrlWithSalonGuid(RouteType.Home))
        }, 10)
      }
    }
  }
}

type UseLoadSalonDataProps = {
  redirectTo?: RouteType
  onSalonDataFetch?: () => void
}

export const useLoadSalonData = ({ redirectTo, onSalonDataFetch }: UseLoadSalonDataProps) => {
  const dispatch = useDispatch()
  const { push: navigate } = useHistory()
  const salonData = useSelector((state: ApplicationState) => state.salon.data)

  useEffect(() => {
    if (!salonData) handleFetchSalonData({ dispatch, navigate, redirectTo, onSalonDataFetch })
  }, [])
}
